import { useMemo } from 'react';
import { generateHTML } from '@tiptap/core';

import { spacing4 } from 'approot/shared/styles/spacing.style';
import { learningSequenceTags } from 'webclient.constants';
import { JSONObject } from 'global/graphql/scalars.type';
import * as Styled from './teaching-learning-sequence.style';
import {
  getExtensions,
  isRichtextEmpty,
} from 'approot/shared/richtext/richtext.utils';

type Props = {
  isSmall?: boolean;
  content?: JSONObject;
  title?: string;
};

const baseSettings = {
  placeholder: '',
  suggestions: learningSequenceTags,
  canBold: true,
  canItalic: true,
  canUnderline: true,
  canAddLists: true,
  canChangeHistory: true,
};

export const TeachingLearningSequenceRichtextTiptap = ({
  content,
  title,
  isSmall,
}: Props) => {
  const extensions = useMemo(() => getExtensions(baseSettings), []);
  const hasRichtext = !isRichtextEmpty(content);

  if (!hasRichtext) return null;

  return (
    <>
      {!!title && (
        <Styled.TeachingLearningSequenceViewTitle marginBottom={spacing4}>
          {title}
        </Styled.TeachingLearningSequenceViewTitle>
      )}
      <Styled.TeachingLearningSequenceRichtext
        $isSmall={isSmall}
        dangerouslySetInnerHTML={{ __html: generateHTML(content, extensions) }}
      />
    </>
  );
};
